import { FormattedMessage } from 'react-intl'

type Props = {
	isOneTimeAuth?: boolean
}

export const DefaultErrorSteps = ({ isOneTimeAuth = false }: Props) => (
	<>
		<FormattedMessage id='flow.errorResolveStepsTitle' defaultMessage='You can try these steps if the issue persists' />
		<ol>
			<li>
				{isOneTimeAuth ? (
					<FormattedMessage
						id='flow.accounts.errorResolveSteps1'
						defaultMessage='Click "Add financial institutes", select your bank, and log in again.'
					/>
				) : (
					<FormattedMessage
						id='flow.errorResolveSteps1'
						defaultMessage='Try to re-open the link and login again with the included password'
					/>
				)}
			</li>
			<li>
				<FormattedMessage id='flow.errorResolveSteps2' defaultMessage='Try again a later' />
			</li>
		</ol>
		<FormattedMessage
			id='flow.errorResolveStepsEnd'
			defaultMessage='If the issue still persists after trying these steps, please reach out to your advisor for help.'
		/>
	</>
)
